import React, {useState} from 'react';

import "./StaffMemberCapture.css";
import {LeftLabelTextInput} from "../../../common/input/left-label-text-input/LeftLabelTextInput";
import {LeftLabelToggle} from "../../../common/input/left-label-toggle/LeftLabelToggle";
import {StandardButton} from "../../../common/button/standard-button/StandardButton";
import {createStaffMember, updateStaffMember} from "../../../../services/StaffMemberService";
import {sendManualRegistrationRequest} from "../../../../services/EmailService";

export const StaffMemberCapture = ({context, navigateBack, navigateTo, setSpinnerText, showToaster}) => {

    const [externalReference] = useState(context.selectedStaffMember ? context.selectedStaffMember.externalReference : null);
    const [username, setUsername] = useState(context.selectedStaffMember ? context.selectedStaffMember.userName : null);
    const [firstName, setFirstName] = useState(context.selectedStaffMember ? context.selectedStaffMember.firstName : null);
    const [lastName, setLastName] = useState(context.selectedStaffMember ? context.selectedStaffMember.lastName : null);
    const [email, setEmail] = useState(context.selectedStaffMember ? context.selectedStaffMember.email : null);
    const [organisation, setOrganisation] = useState(context.selectedStaffMember ? context.selectedStaffMember.organisation : null);
    const [role, setRole] = useState(context.selectedStaffMember ? context.selectedStaffMember.organisationRole : null);
    const [active, setActive] = useState(context.selectedStaffMember ? context.selectedStaffMember.active : false);

    const handleClick = async () => {
        const staffMemberToBeSaved = {
            externalReference,
            userName: username,
            firstName,
            lastName,
            email,
            organisation,
            organisationRole: role,
            active
        };

        if (null === externalReference) {
            setSpinnerText("Creating Staff Member");
            const response = await createStaffMember(context.username, staffMemberToBeSaved);
            handleResponse(response, true);
        } else {
            setSpinnerText("Updating Staff Member");
            const response = await updateStaffMember(context.username, staffMemberToBeSaved);
            handleResponse(response, false);
        }
    }

    const handleResponse = async ([data, error], sendEmail) => {
        if (data) {
            showToaster(data);
            if (data.responseStatus === "Success") {
                if (sendEmail) {
                   await sendManualRegistrationRequest(context.username, username, email);
                }
                navigateTo("staffMemberTable");
            }
            setSpinnerText(null);
        } else {
            showToaster({
                responseStatus: "Error",
                responseMessage: error.message,
            });
            setSpinnerText(null);
        }
    }

    return (
        <div className="staff-member-capture-container">
            <div className="staff-member-capture-form-container">
                <LeftLabelTextInput labelText="First Name:" defaultValue={firstName} handleChange={({target}) => {
                    setFirstName(target.value);
                }}/>
                <LeftLabelTextInput labelText="Last Name:" defaultValue={lastName} handleChange={({target}) => {
                    setLastName(target.value);
                }}/>
                <LeftLabelTextInput labelText="Username:" defaultValue={username} disabled={externalReference}
                                    handleChange={({target}) => {
                                        setUsername(target.value);
                                    }}/>
                <LeftLabelTextInput labelText="Email Address:" defaultValue={email} handleChange={({target}) => {
                    setEmail(target.value);
                }}/>
                <LeftLabelTextInput labelText="Organisation:" defaultValue={organisation} handleChange={({target}) => {
                    setOrganisation(target.value);
                }}/>
                <LeftLabelTextInput labelText="Organisation Role:" defaultValue={role} handleChange={({target}) => {
                    setRole(target.value);
                }}/>
                <LeftLabelToggle labelText="Active:" active={active} setActive={setActive}/>
            </div>
            <div className="staff-member-capture-button-container">
                <StandardButton text={context.selectedStaffMember ? "Update Staff Member" : "Add Staff Member"}
                                onClick={handleClick}/>
                <StandardButton text="Back" onClick={navigateBack}/>
            </div>
        </div>
    );
}
